'use client'

import * as React from 'react'
import { Editor } from '@tiptap/react'

// --- Hooks ---
import { useTiptapEditor } from '@/hooks/use-tiptap-editor'

// --- Tiptap UI ---
import { LinkButton } from '@/tiptap/tiptap-ui/link-popover/link-popover'
import { LinkFloatingEditor } from '@/tiptap/tiptap-ui/link-popover/link-floating-editor'

export interface LinkSelectorProps {
  editor?: Editor | null
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

export function LinkSelector({
  editor: providedEditor,
  open = false,
  onOpenChange,
}: LinkSelectorProps) {
  const { editor } = useTiptapEditor(providedEditor)
  const [isOpen, setIsOpen] = React.useState(open)

  React.useEffect(() => {
    setIsOpen(open)
  }, [open])

  const handleOpenChange = (newOpen: boolean) => {
    setIsOpen(newOpen)
    onOpenChange?.(newOpen)
  }

  if (!editor || !editor.isEditable) {
    return null
  }

  const isActive = editor.isActive('link')

  return (
    <>
      <LinkButton
        onClick={() => handleOpenChange(true)}
        data-active-state={isActive ? 'on' : 'off'}
        className='h-8 w-8 p-0 !rounded-md'
      />
      <LinkFloatingEditor
        editor={editor}
        isOpen={isOpen}
        onClose={() => handleOpenChange(false)}
      />
    </>
  )
}
